import { render, staticRenderFns } from "./PurchaseVip.vue?vue&type=template&id=16e2c182&scoped=true&"
import script from "./PurchaseVip.vue?vue&type=script&lang=js&"
export * from "./PurchaseVip.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseVip.vue?vue&type=style&index=0&id=16e2c182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e2c182",
  null
  
)

export default component.exports